import {
  DriverDocumentsService,
  type DriverDocumentRequestAdmin,
  type PostDriverDocumentsRequestAdmin
} from '@/backend/market'
import { DriverDocumentRepository } from '../../domain/repositories/DriverDocumentRepository'
import { DriverDocumentModel } from '../models/DriverDocumentModel'
import type { DriverDocumentEntity } from '../../domain/entities/DriverDocumentEntity'
import { MissingDriverDocumentModel } from '../models/MissingDriverDocumentModel'
import type { MissingDriverDocumentFilterEntity } from '../../domain/entities/MissingDriverDocumentFilterEntity'
import { MissingDriverDocumentFilterModel } from '../models/MissingDriverDocumentFilterModel'
import type { CreateUpdateDriverDocumentEntity } from '../../domain/entities/CreateUpdateDriverDocumentEntity'
import { CreateUpdateDriverDocumentModel } from '../models/CreateUpdateDriverDocumentModel'
import type { CreateUpdateDocumentsEntity } from '../../domain/entities/CreateUpdateDocumentsEntity'
import { CreateUpdateDocumentsModel } from '../models/CreateUpdateDocumentsModel'
import type { MissingDriverDocumentEntity } from '../../domain/entities/MissingDriverDocumentEntity'

export class DriverDocumentRepositoryImpl implements DriverDocumentRepository {
  async getDriverDocument(driverId: number): Promise<DriverDocumentEntity[] | { error: true }> {
    try {
      const response = await DriverDocumentsService.getDriverDocumentAdmin({
        driverId
      })
      const driverDocumentModels = response.documents?.map((item) => new DriverDocumentModel(item))

      return driverDocumentModels ?? []
    } catch {
      return { error: true }
    }
  }
  async getMissingDriverDocuments(
    filterData: MissingDriverDocumentFilterEntity
  ): Promise<MissingDriverDocumentEntity | { error: true }> {
    const missingDriverDocumentFilterModel = new MissingDriverDocumentFilterModel(filterData)
    try {
      const response = await DriverDocumentsService.getMissingDriverDocumentsAdmin(
        missingDriverDocumentFilterModel
      )
      const missingDriverDocumentModels = new MissingDriverDocumentModel(response)

      return missingDriverDocumentModels
    } catch {
      return { error: true }
    }
  }
  async createDriverDocument(
    documentData: CreateUpdateDriverDocumentEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDriverDocumentModel = new CreateUpdateDriverDocumentModel(documentData)
    try {
      await DriverDocumentsService.postDriverDocumentAdmin({
        requestBody: createUpdateDriverDocumentModel as PostDriverDocumentsRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateDriverDocument(
    documentId: number,
    documentData: CreateUpdateDocumentsEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDocumentsModel = new CreateUpdateDocumentsModel(documentData)
    try {
      await DriverDocumentsService.putDriverDocumentAdmin({
        documentId,
        requestBody: createUpdateDocumentsModel as DriverDocumentRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
